import type { IconSvgObject } from './types';

const WaveTriangleIcon: IconSvgObject = [
  ["path", { d: "M3.00006 12H8.00006L12.0001 19V5L15.9997 12H20.9997", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default WaveTriangleIcon;
